// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3KoTK","disabled":"FileBtn_disabled__2X1Wg","warn":"FileBtn_warn__3qzAX","fade":"FileBtn_fade__3T8qU"};